var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArchiveRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0019 11.0096C13.0019 10.4573 12.5542 10.0096 12.0019 10.0096C11.4496 10.0096 11.0019 10.4573 11.0019 11.0096V15.0958L10.2071 14.3011C9.81658 13.9105 9.18342 13.9105 8.79289 14.3011C8.40237 14.6916 8.40237 15.3247 8.79289 15.7153L10.5877 17.5101C11.3687 18.2911 12.635 18.2911 13.4161 17.5101L15.2071 15.7191C15.5976 15.3285 15.5976 14.6954 15.2071 14.3048C14.8166 13.9143 14.1834 13.9143 13.7929 14.3048L13.0019 15.0958V11.0096Z",
    fill: "#F74F44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.01465 6.83848C2.07842 6.23173 2.34825 5.66176 2.78361 5.2264L5.12132 2.88869C5.68393 2.32608 6.44699 2.01001 7.24264 2.01001H16.7574C17.553 2.01001 18.3161 2.32608 18.8787 2.88869L21.2164 5.2264C21.6518 5.66177 21.9216 6.23173 21.9853 6.83848C21.995 6.89422 22 6.95153 22 7.01001V19.01C22 20.6669 20.6569 22.01 19 22.01H5C3.34315 22.01 2 20.6669 2 19.01V7.01001C2 6.95153 2.00502 6.89421 2.01465 6.83848ZM7.24264 4.01001H16.7574C17.0226 4.01001 17.2769 4.11537 17.4645 4.3029L19.1716 6.01001H4.82843L6.53553 4.3029C6.72307 4.11537 6.97742 4.01001 7.24264 4.01001ZM4 8.01001V19.01C4 19.5623 4.44772 20.01 5 20.01H19C19.5523 20.01 20 19.5623 20 19.01V8.01001H4Z",
    fill: "#F74F44"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveRed);
export default __webpack_public_path__ + "static/media/archive_red.1e10bedac8dcad750d20e7bf1b3eba3b.svg";
export { ForwardRef as ReactComponent };